import React from 'react';
import { StarIcon } from 'lucide-react';
import { heroProof } from '../data/heroProof';
export function HeroProof() {
  return <section aria-label="What instructors say" className="w-full bg-paper" data-id="element-155" data-mp="10uhaohwm1xp1">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-8 sm:py-16" data-id="element-156" data-mp="1fsjd2orwod4p">
        <ul className="grid grid-cols-1 gap-4 lg:grid-cols-3" data-id="element-157" data-mp="1atgadazeeizw">
          {heroProof.map(person => <li key={person.name} className="flex h-full flex-col rounded-2xl border border-sage/15 bg-white p-5 shadow-card sm:p-6" data-id="element-158" data-mp="n32qi7qyvqge">
              <div className="flex items-center gap-3.5" data-id="element-159" data-mp="i2ok0u50kokh">
                <img src={person.photo} alt={`${person.name}, Pilates instructor in ${person.location}`} className="h-14 w-14 shrink-0 rounded-full object-cover" loading="lazy" data-id="element-160" data-mp="wu72cylciv70" />
                <div className="min-w-0" data-id="element-161" data-mp="3vjxkexpse0ic">
                  <div className="flex gap-0.5" aria-label="Five out of five stars" data-id="element-162" data-mp="3vj5mvhcmpspf">
                    {Array.from({
                  length: 5
                }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-brass text-brass" strokeWidth={0} aria-hidden="true" data-id="element-163" data-mp="1ah2vl4tr6qfn" data-mpi={index} />)}
                  </div>
                  <p className="mt-1.5 font-sans text-[14px] font-semibold leading-tight text-ink" data-id="element-164" data-mp="nheuv80eql98">
                    {person.name}
                  </p>
                  <p className="font-sans text-[12px] leading-tight text-ink-muted" data-id="element-165" data-mp="rj0dl9zmhtrc">
                    {person.location}
                  </p>
                </div>
              </div>

              <blockquote className="mt-4 font-sans text-[15px] leading-[1.6] text-ink-soft" data-id="element-166" data-mp="11ihivqayq5ms">
                {person.quote}
              </blockquote>
            </li>)}
        </ul>
      </div>
    </section>;
}